import { createSlice } from '@reduxjs/toolkit';

const initialState = {

    status: 'idle',

    startedAt: null,

    recorderName: '',

    isOwner: false,

    stopRequested: false,
};

const recorderSlice = createSlice({

    name: 'recorder',

    initialState,

    reducers: {

        setRecorderStatus: (
            state,
            action
        ) => {

            state.status = action.payload;
        },

        setRecorderData: (
            state,
            action
        ) => {

            const {
                startedAt,
                recorderName,
                isOwner,
            } = action.payload;

            if (startedAt !== undefined) {
                state.startedAt = startedAt;
            }

            if (recorderName !== undefined) {
                state.recorderName =
                    recorderName;
            }

            if (isOwner !== undefined) {
                state.isOwner = isOwner;
            }
        },

        requestStopRecording: (
            state
        ) => {

            state.stopRequested = true;
        },

        clearStopRequest: (
            state
        ) => {

            state.stopRequested = false;
        },

        resetRecorderState: (
            state
        ) => {

            state.status = 'idle';

            state.startedAt = null;

            state.recorderName = '';

            state.isOwner = false;

            state.stopRequested = false;
        },
    },
});

export const {

    setRecorderStatus,

    setRecorderData,

    requestStopRecording,

    clearStopRequest,

    resetRecorderState,

} = recorderSlice.actions;

export default recorderSlice.reducer;